export const CSS_DRAGOVER_CLASS = 'frm_upload_dropzone--dragover';
export const CSS_LIMIT_REACHED_CLASS = 'frm_upload_dropzone--limit-reached';

export const SELECTORS = {
	errorContainer: '.frm_upload_error_messages',
	preview: '.frm_upload_file_preview',
	previewContainer: '.frm_upload_preview_container',
	previewCount: '.frm_upload_preview_count',
	previewItem: '.frm_upload_file_preview',
	previewProgress: '.frm_upload_preview_progress',
	previewProgressText: '.frm_upload_progress_text',
	removeButton: '.frm_upload_preview_remove_file',
};
